import React, { useState, useEffect } from "react";
import "../../css/Time-data.css";
import api from "../../api/api";
import { Link, useNavigate } from "react-router-dom";

const TimeData = () => {
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isStartDisabled, setIsStartDisabled] = useState(false);
  const [isEndDisabled, setIsEndDisabled] = useState(true);

  const [breakStatus, setBreakStatus] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const [showStartUpload, setShowStartUpload] = useState(false);
  const [showEndUpload, setShowEndUpload] = useState(false);

  const [meterImage, setMeterImage] = useState(null);
  const [meterReading, setMeterReading] = useState("");

  const [breakStartTime, setBreakStartTime] = useState(null);
  const [breakEndTime, setBreakEndTime] = useState(null);

  const [attendance, setAttendance] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const [apiKey, setApiKey] = useState(null);

  

 useEffect(() => {
  const fetchApiKey = async () => {
    try {
      const response = await api.get("/setting/get/key");
      const key_value = response?.data?.data?.[0]?.key_value;

      if (key_value) {
        setApiKey(key_value);
      } else {
        console.error("API key not found");
      }
    } catch (error) {
      console.error("Failed to fetch API key:", error);
    }
  };

  fetchApiKey();
}, []);



 const fetchLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return reject(new Error("Geolocation not supported"));
    }

    if (!apiKey) {
      alert("API key not loaded yet, please wait.");
      return reject(new Error("API key missing"));
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
          );
           const data = await response.json();

            if (data && data.results && data.results.length > 0) {
              const locationDetails = data.results[0];
              const formattedAddress = locationDetails.formatted;

              resolve({
                lat: latitude,
                lng: longitude,
                address: formattedAddress,
              });
              
          } else {
            alert("Could not retrieve refined coordinates from Google.");
            reject(new Error("No valid location data from Google Geocode API"));
          }
        } catch (apiError) {
          alert("Failed to contact Google Geocode API.");
          reject(apiError);
        }
      },
      (error) => {
        if (error.code === 1) {
          alert("You denied location access. Please allow it in browser settings.");
        } else if (error.code === 2) {
          alert("Location unavailable. Try again later.");
        } else if (error.code === 3) {
          alert("Location request timed out.");
        } else {
          alert("Unknown geolocation error.");
        }

        reject(error);
      }
    );
  });
};





 const handleStartUploadSubmit = async () => {
  if (!meterImage) {
    alert("Please upload an image!");
    return;
  }

  if (!meterReading) {
    alert("Please enter the meter reading!");
    return;
  }

  if (!(meterImage instanceof File)) {
    alert("Invalid file uploaded.");
    return;
  }

  try {
    setIsSubmitting(true);
    const location = await fetchLocation();
    const formData = new FormData();

    formData.append("meter_image", meterImage);
    formData.append("clock_in_latitude", location.lat);
    formData.append("clock_in_longitude", location.lng);
    formData.append("meter_reading", meterReading);
   

    const response = await api.post("/startAttendance", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Start Time Recorded:", response.data);

    setStartTime(new Date());
    setIsStartDisabled(true);
    setIsEndDisabled(false);
    setShowStartUpload(false);
    setMeterImage(null);
    setMeterReading("");
    alert("✅ Start time recorded successfully!");
  } catch (error) {
    console.error("Start time error:", error);
    alert("❌ Failed to record start time. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};


  const handleEndUploadSubmit = async () => {
  if (!meterImage) {
    alert("Please upload an image!");
    return;
  }

  if (!meterReading) {
    alert("Please enter the meter reading!");
    return;
  }

  if (!(meterImage instanceof File)) {
    alert("Invalid file uploaded.");
    return;
  }

  try {
    setIsSubmitting(true);
    const location = await fetchLocation();
    const formData = new FormData();

    formData.append("meter_image", meterImage);
    formData.append("clock_out_latitude", location.lat);
    formData.append("clock_out_longitude", location.lng);
    formData.append("meter_reading", meterReading);
   

    const response = await api.post("/endAttendance", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("End Time Recorded:", response.data);

    setEndTime(new Date());
    setIsEndDisabled(true);
    setShowEndUpload(false);
    setMeterImage(null);
    setMeterReading("");
    alert("✅ End time recorded successfully!");
  } catch (error) {
    console.error("End time error:", error);
    alert("❌ Failed to record end time. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};


 const handleBreakToggle = async () => {
  try {
    setIsSubmitting(true);
    const location = await fetchLocation();
    const now = new Date();

    if (breakStatus === "started") {
      const res = await api.post("/endBreak", {
        latitude: location.lat,
        longitude: location.lng,
     
      });

      setBreakStatus("stopped");
      setBreakEndTime(now);

      setAttendance((prev) => ({
        ...prev,
        break_end_time: now.toLocaleTimeString(),
      }));

      alert("🛑 Break stopped successfully!");
      window.location.reload(); 
      
    } else {
      const res = await api.post("/startBreak", {
        latitude: location.lat,
        longitude: location.lng,
       
      });

      setBreakStatus("started");
      setBreakStartTime(now);

      setAttendance((prev) => ({
        ...prev,
        break_start_time: now.toLocaleTimeString(),
        break_end_time: null,
      }));

      alert("☕ Break started successfully!");
    }
  } catch (error) {
    console.error("Break error:", error);
    alert("❌ Failed to update break status. Try again.");
  } finally {
    setIsSubmitting(false);
  }
};




  const handlePasswordChange = async () => {
    try {
      const response = await api.post("/employee-change-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });

      if (response.data.success) {
        setPasswordMessage("Password changed successfully.");
        setCurrentPassword("");
        setNewPassword("");
        setTimeout(() => {
          setShowModal(false);
          setPasswordMessage("");
          navigate("/login");
        }, 1500);
      } else {
        setPasswordMessage("Failed to change password.");
      }
    } catch (error) {
      setPasswordMessage("Error changing password.");
      console.error("Password change error:", error);
    }
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await api.get("/employee-profile");
        const result = response.data;
        if (result.success) {
          setUserData({
            username: result.data.username,
            company: result.data.company,
            designation: result.data.designation,
          });
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    api
      .get("/getAttendence")
      .then((response) => {
        if (response.data.success) {
          setAttendance(response.data.data);
        } else {
          setError("Data fetch failed");
        }
      })
      .catch((err) => {
        setError("Error fetching attendance");
        console.error(err);
      });
  }, []);

  // 🔄 Update button states based on attendance
  useEffect(() => {
    if (attendance) {
      setIsStartDisabled(!!attendance.clock_in);
      setIsEndDisabled(!!attendance.clock_out ? true : !attendance.clock_in);

      if (attendance.break_start_time && !attendance.break_end_time) {
        setBreakStatus("started");
      } else if (attendance.break_start_time && attendance.break_end_time) {
        setBreakStatus("stopped");
      }
    }
  }, [attendance]);

  if (!attendance && !error) {
    return <div>Loading...</div>;
  }

  return (
    <section className="section-time">
      <div className="container">
        <div className="inner-content">
          <div className="left-side">
            <div className="content-wrap">
              <div className="top-content">
                <div className="img-box">
                  <img src="/images/site-logo.png" />
                </div>
                <div className="btn-group">
                  <Link to="#" onClick={() => setShowModal(true)}>
                    Edit Profile
                  </Link>
                </div>
              </div>
              <div className="bottom-content">
                <h2>{userData?.company || "Loading..."}</h2>
                <div className="user-profile-img">
                  <img src="/images/p-1.png" alt="Profile" />
                </div>
                <div className="user-datiles">
                  <h3>{userData?.username || "Loading..."}</h3>
                  <h5>{userData?.designation || "Loading..."}</h5>
                </div>
                <div className="time-btn-group">
                  <div className="btn-002">
                    <div className="time-date">
                      <p>
                        Date:{" "}
                        {(startTime && startTime.toLocaleDateString()) ||
                          attendance?.date ||
                          ""}
                      </p>
                      <p>
                        Time:{" "}
                        {(startTime && startTime.toLocaleTimeString()) ||
                          attendance?.clock_in ||
                          ""}
                      </p>
                    </div>
                    <button
                      onClick={() => setShowStartUpload(true)}
                      disabled={isStartDisabled || attendance?.clock_in}
                    >
                      Start Time
                    </button>
                  </div>

                  <div className="btn-002">
                    <div className="time-date">
                      <p>
                        Start Break:{" "}
                        {(breakStartTime &&
                          breakStartTime.toLocaleTimeString()) ||
                          attendance?.break_start_time ||
                          ""}
                      </p>
                      <p>
                        Stop Break:{" "}
                        {(breakEndTime && breakEndTime.toLocaleTimeString()) ||
                          attendance?.break_end_time ||
                          ""}
                      </p>
                    </div>
                    <button
                      onClick={handleBreakToggle}
                      disabled={
                        !(attendance?.clock_in || startTime) ||
                        (attendance?.break_start_time &&
                          attendance?.break_end_time)
                      }
                    >
                      {breakStatus === "started" ? "Stop Break" : "Start Break"}
                    </button>
                  </div>

                  <div className="btn-002">
                    <div className="time-date">
                      <p>
                        Date:{" "}
                        {(endTime && endTime.toLocaleDateString()) ||
                          attendance?.date ||
                          ""}
                      </p>
                      <p>
                        Time:{" "}
                        {(endTime && endTime.toLocaleTimeString()) ||
                          attendance?.clock_out ||
                          ""}
                      </p>
                    </div>
                    <button
                      onClick={() => setShowEndUpload(true)}
                      disabled={
                        !(attendance?.clock_in || startTime) ||
                        !(attendance?.break_start_time || breakStartTime) ||
                        !(attendance?.break_end_time || breakEndTime) ||
                        isEndDisabled ||
                        attendance?.clock_out
                      }
                    >
                      End Time
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right-side">
            <img src="./images/h-3.jpg" alt="Health" />
          </div>
        </div>
      </div>

      {/* Start Upload Modal */}
      {showStartUpload && (
        <div className="password-modal-overlay">
          <div className="password-modal">
            <h3>Upload Meter Image & Reading (Start)</h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setMeterImage(e.target.files[0])}
            />
            <input
              type="number"
              placeholder="Meter Reading"
              value={meterReading}
              onChange={(e) => setMeterReading(e.target.value)}
            />

            <button
              className="btn-001"
              onClick={handleStartUploadSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Start"}
            </button>

            <button onClick={() => setShowStartUpload(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* End Upload Modal */}
      {showEndUpload && (
        <div className="password-modal-overlay">
          <div className="password-modal">
            <h3>Upload Meter Image & Reading (End)</h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setMeterImage(e.target.files[0])}
            />
            <input
              type="number"
              placeholder="Meter Reading"
              value={meterReading}
              onChange={(e) => setMeterReading(e.target.value)}
            />
            <button
              className="btn-001"
              onClick={handleEndUploadSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit End"}
            </button>

            <button onClick={() => setShowEndUpload(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* Password Modal */}
      {showModal && (
        <div className="password-modal-overlay">
          <div className="password-modal">
            <h3>Setup New Password</h3>
            <p>Please, setup a new password for your account</p>

            <div className="password-input-wrapper">
              <input
                type={showCurrent ? "text" : "password"}
                placeholder="Old Password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <span
                onClick={() => setShowCurrent(!showCurrent)}
                className="eye-toggle"
              >
                {showCurrent ? "🙈" : "👁️"}
              </span>
            </div>

            <div className="password-input-wrapper">
              <input
                type={showNew ? "text" : "password"}
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span onClick={() => setShowNew(!showNew)} className="eye-toggle">
                {showNew ? "🙈" : "👁️"}
              </span>
            </div>

            <button className="btn-001" onClick={handlePasswordChange}>
              Submit
            </button>
            <button onClick={() => setShowModal(false)}>Cancel</button>
            {passwordMessage && (
              <p className="password-msg">{passwordMessage}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default TimeData;
